<template>
  <div>
    <vue-element-loading :active="isSubmit" />
    <v-card class="users-main-card" elevation="0">
      <div class="users-card-header" :class="'header-' + userType">
        <div class="users-card-header-left">
          <div class="users-card-header-icon">
            <v-icon color="white" size="20">{{ getIcon(userType) }}</v-icon>
          </div>
          <span class="users-card-header-title">{{ capitalizeFirstLetter(userType) }}</span>
        </div>
        <div class="users-card-header-right">
        <create-button
          v-if="userType === 'schools'"
          @create="showCreateSchoolDialog"
        ></create-button>
        <div v-else-if="userType === 'students'">
          <v-btn
            class="mr-2"
            color="info"
            @click="exportUsers"
            :loading="status === 'loading-export-users'"
          >
            <v-icon class="me-2">mdi-file-excel</v-icon>
            <span> {{ $t('pages.export_users') }}</span>
          </v-btn>
          <v-btn
            class="mr-2"
            color="info"
            @click="downloadTemplate"
            :loading="status === 'loading-download-template'"
          >
            <v-icon class="me-2">mdi-file-download</v-icon>
            <span> {{ $t('pages.download_xlsx_template') }}</span>
          </v-btn>
          <v-btn
            color="primary mr-2"
            @click="openUploadFile"
            :loading="status === 'loading-upload-file'"
          >
            <v-icon class="me-2">mdi-file-upload</v-icon>
            <span> {{ $t('pages.upload_xlsx_template') }}</span>
          </v-btn>
          <v-btn v-if="!$isDirector" color="primary" to="/students/create">
            <v-icon class="me-2">mdi-account-plus</v-icon>
            <span>{{ $t('pages.create') }}</span>
          </v-btn>
          <input
            type="file"
            id="file"
            ref="file"
            style="display: none"
            accept=".xlsx"
            @change="uploadTemplateFile"
          />
        </div>
        <div v-else-if="userType === 'guardians'">
          <v-btn
            class="mr-2"
            color="info"
            @click="exportUsers"
            :loading="status === 'loading-export-users'"
          >
            <v-icon class="me-2">mdi-file-excel</v-icon>
            <span> {{ $t('pages.export_users') }}</span>
          </v-btn>
          <v-btn v-if="!$isDirector" color="primary" to="/guardians/create">
            <v-icon class="me-2">mdi-account-plus</v-icon>
            <span>{{ $t('pages.create') }}</span>
          </v-btn>
        </div>
        <div v-else-if="userType === 'drivers'">
          <v-btn
            class="mr-2"
            color="info"
            @click="exportUsers"
            :loading="status === 'loading-export-users'"
          >
            <v-icon class="me-2">mdi-file-excel</v-icon>
            <span> {{ $t('pages.export_users') }}</span>
          </v-btn>
          <v-btn v-if="!$isDirector" color="primary" to="/drivers/create">
            <v-icon class="me-2">mdi-account-plus</v-icon>
            <span>{{ $t('pages.create') }}</span>
          </v-btn>
        </div>
        </div>
      </div>
      <v-tabs v-model="active_tab" show-arrows class="mt-0 mb-2">
        <v-tab v-for="tab in tabs" :key="tab.idx">
          <v-icon size="20" class="me-3">
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>
      </v-tabs>
      <!-- tabs item -->
      <v-tabs-items touchless v-model="active_tab">
        <!-- active -->
        <v-tab-item>
          <users-table
            :users="activeUsers"
            :userType="userType"
            :tab="active_tab"
            :mode="mode"
            :total-users="totalUsers"
            :options="options"
            @update:search="search = $event"
            @update:options="options = $event"
            @view-user="viewUser"
            @edit-user="editUser"
            @suspend-user="suspendActivateUser"
            @unassign-bus="unAssignBus"
            @assign-bus="assignBus"
            @set-student-bus="setStudentBus"
            @login-as-school="loginAsSchool"
            @delete-school="deleteSchool"
            @show-student-location="showStudentLocation"
            @delete-user="deleteUser"
          ></users-table>
        </v-tab-item>

        <!-- suspended -->
        <v-tab-item>
          <users-table
            :users="suspendedUsers"
            :userType="userType"
            :tab="active_tab"
            :mode="mode"
            @view-user="viewUser"
            @edit-user="editUser"
            @suspend-user="suspendActivateUser"
            @unassign-bus="unAssignBus"
            @assign-bus="assignBus"
            @login-as-school="loginAsSchool"
            @delete-school="deleteSchool"
          ></users-table>
        </v-tab-item>

        <!-- <v-tab-item>
          <users-table
            v-if="userType === 'drivers' || userType === 'students'"
            :users="underReviewUsers"
            :mode="mode"
            :userType="userType"
            :tab="active_tab"
            @view-user="viewUser"
          ></users-table>
        </v-tab-item> -->

        <!--        <v-tab-item>-->
        <!--          <users-table-->
        <!--            v-if="userType === 'students'"-->
        <!--            :users="outOfCoinsUsers"-->
        <!--            :mode="mode"-->
        <!--            :userType="userType"-->
        <!--            :tab="active_tab"-->
        <!--            @view-user="viewUser"-->
        <!--          ></users-table>-->
        <!--        </v-tab-item>-->

        <v-tab-item>
          <users-table
            v-if="userType === 'students'"
            :users="noBusAssociatedUsers"
            :mode="mode"
            :userType="userType"
            :tab="active_tab"
            @view-user="viewUser"
          ></users-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-dialog v-if="selectedDriver" v-model="busesDialog" max-width="390">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t('pages.select_bus_for') }} '{{ selectedDriver.name }}'
        </v-card-title>

        <v-card-text>
          <v-list dense>
            <v-subheader>{{ $t('pages.buses') }}</v-subheader>
            <v-list-item-group>
              <v-list-item v-for="(bus, i) in availableBuses" :key="i">
                <v-list-item-content @click="assignBusToDriver(bus)">
                  <v-list-item-title
                    v-text="$t('pages.license') + ': ' + bus.license"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="$t('pages.capacity') + ': ' + bus.capacity"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-container style="height: 400px">
          <v-row
            v-show="loadingBuses"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col class="text-subtitle-1 text-center" cols="12">
              Please wait ...
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                :active="loadingBuses"
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="closeBusDialog">
            {{ $t('actions.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="selectedStudent"
      v-model="busesForStudentDialog"
      max-width="490"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t('actions.select') }}
          {{ +selectedStudentMorning === 1 ? 'morning' : 'afternoon' }}
          {{ $t('actions.bus_for') }} '{{ selectedStudent.name }}'
        </v-card-title>

        <v-card-text>
          <v-list dense>
            <v-subheader>{{ $t('pages.buses') }}</v-subheader>
            <v-list-item-group>
              <v-list-item v-for="(bus, i) in availableBuses" :key="i">
                <v-list-item-content @click="assignBusToStudent(bus)">
                  <v-list-item-title
                    v-text="$t('pages.license') + ': ' + bus.license"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="$t('pages.capacity') + ': ' + bus.capacity"
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-text="
                      $t('pages.available_seats') + ': ' + bus.available_seats
                    "
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-container style="height: 400px">
          <v-row
            v-show="loadingBuses"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col class="text-subtitle-1 text-center" cols="12">
              Please wait ...
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                :active="loadingBuses"
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="closeStudentBusDialog">
            {{ $t('actions.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="schoolDialog" persistent max-width="700px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">
                {{ $t('pages.organisation_account') }}
              </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="name"
                      :rules="nameRules"
                      :label="$t('pages.name') + '*'"
                      :hint="$t('pages.name_of_the_organisation')"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" v-if="userType === 'schools'">
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      :label="$t('pages.email') + '*'"
                      :hint="$t('pages.email_of_the_organisation_account')"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6" v-if="userType === 'schools'">
                    <v-text-field
                      v-model="password"
                      :rules="passRules"
                      :label="$t('pages.password') + '*'"
                      :hint="$t('pages.password_of_the_organisation_account')"
                      type="password"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="schoolDialog = false">
                {{ $t('actions.close') }}
              </v-btn>
              <v-btn color="blue darken-1" text @click="createSchool">
                {{ $t('actions.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import usersTable from './users-table.vue';
import { mdiAirplane, mdiMotionPause, mdiBusSchool } from '@mdi/js';
import VueElementLoading from 'vue-element-loading';
import auth from '@/services/AuthService';
import CreateButton from '@/components/CreateButton';
import firebase from 'firebase/compat/app';

export default {
  components: {
    VueElementLoading,
    usersTable,
    CreateButton,
  },
  data() {
    return {
      mode: null,
      file: null,
      userType: '',
      users: [],
      totalUsers: 0,
      options: {},
      activeUsers: [],
      suspendedUsers: [],
      underReviewUsers: [],
      outOfCoinsUsers: [],
      noBusAssociatedUsers: [],
      availableBuses: [],
      dialog: false,
      busesDialog: false,
      busesForStudentDialog: false,
      loadingBuses: false,
      isSubmit: false,
      selectedUser: null,
      selectedDriver: null,
      selectedStudent: null,
      selectedStudentMorning: null,
      tabs: [],
      driverTabs: [
        { idx: 0, title: this.$t('table.active'), icon: mdiAirplane },
        { idx: 1, title: this.$t('table.suspended'), icon: mdiMotionPause },
        // { idx: 2, title: this.$t('table.under_review'), icon: mdiAccountClock },
      ],
      studentTabs: [
        { idx: 0, title: this.$t('table.active'), icon: mdiAirplane },
        { idx: 1, title: this.$t('table.suspended'), icon: mdiMotionPause },
        // { idx: 2, title: this.$t('table.under_review'), icon: mdiAccountClock },
        // { idx: 3, title: this.$t('table.out_of_coins'), icon: mdiAccountQuestion },
        {
          idx: 4,
          title: this.$t('table.no_bus_associated'),
          icon: mdiBusSchool,
        },
      ],
      defaultTabs: [
        { idx: 0, title: this.$t('table.active'), icon: mdiAirplane },
        { idx: 1, title: this.$t('table.suspended'), icon: mdiMotionPause },
      ],
      active_tab: null,
      name: '',
      nameRules: [
        (v) => !!v || this.$t('forms.school_name_is_required'),
        (v) =>
          (v && v.length <= 15) ||
          this.$t('forms.school_name_must_be_less_than_15_characters'),
      ],
      email: '',
      emailRules: [
        (v) => !!v || this.$t('forms.e_mail_is_required'),
        (v) => /.+@.+\..+/.test(v) || this.$t('forms.e_mail_must_be_valid'),
      ],
      password: '',
      passRules: [(v) => !!v || this.$t('forms.password_is_required')],
      schoolDialog: false,
      valid: true,
      search: '',
      status: '',
    };
  },
  watch: {
    $route(to, from) {
      this.userType = to.name;
      if (this.userType === 'organisations') {
        this.userType = 'schools';
      }
      this.updateTabs();
      if (this.userType === 'drivers') {
        this.active_tab = parseInt(localStorage.tabIdxDrivers) || 0;
      } else if (this.userType === 'students') {
        this.active_tab = parseInt(localStorage.tabIdxStudents) || 0;
      } else if (this.userType === 'parents') {
        this.active_tab = parseInt(localStorage.tabIdxParents) || 0;
      } else if (this.userType === 'schools') {
        this.active_tab = parseInt(localStorage.tabIdxSchools) || 0;
      }
      this.loadUsers();
    },
    active_tab: function (newVal, oldVal) {
      if (this.userType === 'organisations') {
        this.userType = 'schools';
      }
      if (this.userType === 'drivers') {
        localStorage.tabIdxDrivers = newVal;
      } else if (this.userType === 'parents') {
        localStorage.tabIdxParents = newVal;
      } else if (this.userType === 'students') {
        localStorage.tabIdxStudents = newVal;
      } else if (this.userType === 'schools') {
        localStorage.tabIdxSchools = newVal;
      }

      if (this.userType === 'students' || this.userType === 'guardians') {
        this.loadUsers();
      }
    },
    options: {
      handler() {
        this.loadUsers();
      },
      deep: true,
    },
    search: function () {
      this.loadUsers();
    },
  },
  mounted() {
    this.mode = auth.getMode();
    this.userType = this.$router.currentRoute.name;
    if (this.userType === 'organisations') {
      this.userType = 'schools';
    }
    this.updateTabs();
    if (this.userType === 'drivers') {
      this.active_tab = parseInt(localStorage.tabIdxDrivers) || 0;
    } else if (this.userType === 'parents') {
      this.active_tab = parseInt(localStorage.tabIdxParents) || 0;
    } else if (this.userType === 'students') {
      this.active_tab = parseInt(localStorage.tabIdxStudents) || 0;
    } else if (this.userType === 'schools') {
      this.active_tab = parseInt(localStorage.tabIdxSchools) || 0;
    }
    this.loadUsers();
    //load buses for drivers
    if (this.userType === 'drivers') {
      this.loadAvailableBuses();
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    async createSchool() {
      if (this.validate()) {
        this.error = null;
        try {
          this.isSubmit = true;
          var result = await firebase
            .auth()
            .createUserWithEmailAndPassword(this.email, this.password);
          var token = await result.user.getIdToken(true);
          var response = await axios.post('/auth/loginViaToken', {
            device_name: `${vm.$browserDetect.meta.name}- v${vm.$browserDetect.meta.version}`,
            token,
            role: 2,
            name: this.name,
            email: this.email,
          });
          this.users.push(response.data.user_data);
          this.activeUsers = this.users.filter((user) => user.status_id === 1);
          this.suspendedUsers = this.users.filter(
            (user) => user.status_id === 3
          );
          //add school to active users
          // this.activeUsers.push(response.data.user_data);
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.organisation_created'),
            type: 'success',
          });
          this.schoolDialog = false;
          this.isSubmit = false;
        } catch (error) {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error'),
            type: 'error',
          });
          // this.$swal(
          //   this.$t('messages.error'),
          //   error.response.data.message,
          //   'error'
          // );
        }
      }
    },
    showCreateSchoolDialog() {
      this.name = '';
      this.email = '';
      this.password = '';
      this.schoolDialog = true;
    },
    updateTabs() {
      if (this.userType === 'drivers') {
        this.tabs = this.driverTabs;
      } else if (this.userType === 'students') {
        this.tabs = this.studentTabs;
      } else {
        this.tabs = this.defaultTabs;
      }
    },
    capitalizeFirstLetter(string) {
      if (!string) return;
      let name = string;
      if (name === 'schools') {
        name = 'organisations';
      }
      name = this.$t('pages.' + name);
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name?.replace('-', ' ');
    },
    getIcon(userType) {
      switch (userType) {
        case 'schools':
          return 'mdi-domain';
        case 'students':
          return 'mdi-badge-account-outline';
        case 'drivers':
          return 'mdi-account-tie-hat';
        case 'guardians':
          return 'mdi-account-group-outline';
        default:
          break;
      }
    },
    loadUsers() {
      this.isSubmit = true;
      let url = '/users/all-' + this.userType;
      this.users = [];
      const params = {
        page: this.options?.page ?? 1,
        per_page: this.options?.itemsPerPage ?? 10,
        order_by: this.options?.sortBy?.[0],
        order_direction:
          this.options?.sortDesc?.[0] === null ||
          this.options?.sortDesc?.[0] === undefined
            ? null
            : this.options?.sortDesc?.[0] === true
            ? 'DESC'
            : 'ASC',
        search: this.search,
        status: this.active_tab + 1,
      };
      axios
        .get(url, { params })
        .then((response) => {
          this.users = response.data?.data ?? response.data;
          this.totalUsers = response.data?.total;

          if (this.userType === 'students') {
            if (this.active_tab === 0) {
              this.activeUsers = this.users;
            }
            if (this.active_tab === 1) {
              this.suspendedUsers = this.users;
            }
            if (this.active_tab === 2 && this.userType === 'students') {
              this.noBusAssociatedUsers = this.users;
            }
          } else {
            this.activeUsers = this.users.filter(
              (user) => user.status_id === 1
            );
            this.suspendedUsers = this.users.filter(
              (user) => user.status_id === 3
            );
            this.underReviewUsers = this.users.filter(
              (user) => user.status_id === 4
            );
            this.outOfCoinsUsers = this.users.filter(
              (user) => user.status_id === 5
            );
          }
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_retrieving_users'),
            type: 'error',
          });
          auth.checkError(
            error.response.data.message,
            this.$router,
            this.$swal
          );
        })
        .then(() => {
          this.isSubmit = false;
        });
    },
    deleteSchool(school) {
      this.$swal
        .fire({
          title: this.$t('actions.delete_organisation'),
          text:
            this.$t('actions.are_you_sure_to_delete_the_account_of') +
            " '" +
            school.name +
            "' ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('actions.yes_delete'),
          confirmButtonColor: '#f44336',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteSchoolServer(school);
          }
        });
    },
    deleteSchoolServer(school) {
      this.isSubmit = true;
      axios
        .delete('/users/delete-school', {
          data: {
            school_id: school.id,
          },
        })
        .then(() => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.school_deleted'),
            type: 'success',
          });
          this.users = this.users.filter((user) => user.id !== school.id);
          this.activeUsers = this.users.filter((user) => user.status_id === 1);
          this.suspendedUsers = this.users.filter(
            (user) => user.status_id === 3
          );
        })
        .catch(() => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        });
    },
    loginAsSchool(school) {
      this.$swal
        .fire({
          title: this.$t('actions.login_as_organisation'),
          text:
            this.$t('actions.are_you_sure_to_login_as') +
            " '" +
            school.name +
            "' ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('actions.yes_login'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.loginAsSchoolServer(school);
          }
        });
    },
    loginAsSchoolServer(school) {
      //post to backend login-from-admin-to-school
      this.isSubmit = true;
      axios
        .post('/auth/login-from-admin-to-school', {
          school_id: school.id,
          device_name: `${vm.$browserDetect.meta.name}- v${vm.$browserDetect.meta.version}`,
        })
        .then((response) => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.logged_in_as') + ' ' + school.name,
            type: 'success',
          });
          const ourToken = response.data.token;
          let user = response.data.user_data;
          const userRole = user.role_id;
          const simple_mode = response.data.simple_mode;
          const freshToken = ourToken.split('|')[1];
          localStorage.setItem('freshToken', freshToken);
          localStorage.setItem('userRole', userRole);
          localStorage.setItem('simple_mode', simple_mode);
          axios.defaults.headers.common[
            'Authorization'
          ] = `Bearer ${freshToken}`;
          //redirect to school dashboard
          this.$router.push({
            name: 'school-dashboard',
          });
        })
        .catch(() => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        });
    },
    viewUser(user) {
      let userType = this.userType.slice(0, -1);
      let routeName = 'view-' + userType;
      if (routeName === 'view-school') {
        routeName = 'view-organisation';
      }
      this.$router.push({
        name: routeName,
        params: {
          user_id: user.id,
        },
      });
    },
    showStudentLocation(student) {
      this.$router.push({
        name: 'student-location',
        params: {
          student_id: student.id,
        },
      });
    },
    editUser(user) {
      let userType = this.userType.slice(0, -1);
      let routeName = 'edit-' + userType;
      if (routeName === 'edit-school') {
        routeName = 'edit-organisation';
      }
      this.$router.push({
        name: routeName,
        params: {
          user_id: user.id,
        },
      });
    },
    suspendActivateUser(user, index) {
      //remove (s) from userType
      let userType = this.userType.slice(0, -1);
      this.$swal
        .fire({
          title:
            (user.status_id != 1
              ? this.$t('pages.activate')
              : this.$t('pages.suspend')) +
            ' ' +
            this.$t('pages.' + userType),
          text:
            this.$t('actions.are_you_sure_to') +
            ' ' +
            (user.status_id != 1
              ? this.$t('pages.activate')
              : this.$t('pages.suspend')) +
            " '" +
            user.name +
            "' ?",
          icon:
            user.status_id != 1
              ? this.$t('messages.success')
              : this.$t('messages.error'),
          showCancelButton: true,
          confirmButtonText: this.$t('actions.yes'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.suspendActivateUserServer(user, index);
          }
        });
    },
    suspendActivateUserServer(user, indexx) {
      this.isSubmit = true;
      axios
        .post('/users/suspend-activate', {
          user_id: user.id,
        })
        .then((response) => {
          this.isSubmit = false;
          //get the index
          let index = this.users.indexOf(user);
          this.users[index].status_id = user.status_id != 1 ? 1 : 3;
          this.activeUsers = this.users.filter((user) => user.status_id === 1);
          this.suspendedUsers = this.users.filter(
            (user) => user.status_id === 3
          );
          this.$notify({
            title: this.$t('messages.success'),
            text:
              'User ' +
              (user.status_id != 1
                ? this.$t('messages.suspended')
                : this.$t('messages.activated')),
            type: 'success',
          });
        })
        .catch(() => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        });
    },
    loadAvailableBuses() {
      this.loadingBuses = true;
      this.availableBuses = [];
      axios
        .get('/drivers/available-buses')
        .then((response) => {
          this.availableBuses = response.data;
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_retrieving_buses'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          this.loadingBuses = false;
        });
    },
    loadAllBuses(is_morning) {
      this.loadingBuses = true;
      this.availableBuses = [];
      axios
        .get('/drivers/all-buses')
        .then((response) => {
          this.availableBuses = response.data;
          if (is_morning == 1) {
            //add available seats to the buses
            this.availableBuses.forEach((bus) => {
              bus.available_seats = bus.available_morning_seats;
            });
          } else {
            //add available seats to the buses
            this.availableBuses.forEach((bus) => {
              bus.available_seats = bus.available_afternoon_seats;
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_retrieving_buses'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          this.loadingBuses = false;
        });
    },
    assignBus(item) {
      this.selectedDriver = item;
      this.busesDialog = true;
      this.loadAvailableBuses();
    },
    setStudentBus(item, is_morning) {
      this.selectedStudentMorning = is_morning;
      this.selectedStudent = item;
      this.busesForStudentDialog = true;
      this.loadAllBuses(is_morning);
    },
    closeStudentBusDialog() {
      this.busesForStudentDialog = false;
      this.loadingBuses = false;
      this.availableBuses = [];
    },
    closeBusDialog() {
      this.busesDialog = false;
      this.loadingBuses = false;
      this.availableBuses = [];
    },
    assignBusToStudent(bus) {
      this.loadingBuses = true;
      axios
        .post('/users/assign-student-bus', {
          student_id: this.selectedStudent.id,
          bus_id: bus.id,
          is_morning: this.selectedStudentMorning,
        })
        .then((response) => {
          this.selectedStudent.student_settings =
            response.data.student_settings;
          this.loadingBuses = false;
          this.closeStudentBusDialog();
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.bus_assigned_to_student'),
            type: 'success',
          });
        })
        .catch(() => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          this.closeStudentBusDialog();
        });
    },
    assignBusToDriver(bus) {
      this.loadingBuses = true;
      axios
        .post('/drivers/assign-bus', {
          driver_id: this.selectedDriver.id,
          bus_id: bus.id,
        })
        .then(() => {
          this.loadingBuses = false;
          this.selectedDriver.bus = bus;
          this.closeBusDialog();
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.bus_assigned_to_driver'),
            type: 'success',
          });
        })
        .catch((error) => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          this.closeBusDialog();
        });
    },
    unAssignBus(item) {
      this.$swal
        .fire({
          title: this.$t('actions.un_assign_bus'),
          text:
            this.$t('actions.are_you_sure_to_un_assign_the_driver') +
            " ' " +
            item.name +
            " ' " +
            this.$t('actions.from_the_bus') +
            " '" +
            item.bus.license +
            "' ? " +
            this.$t('actions.you_wont_be_able_to_revert_this') +
            '!',
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: this.$t('actions.yes_delete_it') + '!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.unassignBusFromDriver(item);
          }
        });
    },
    unassignBusFromDriver(driver) {
      this.isSubmit = true;
      axios
        .post('/drivers/unassign-bus', {
          driver_id: driver.id,
        })
        .then(() => {
          this.isSubmit = false;
          driver.bus = null;
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.bus_unassigned_from_driver'),
            type: 'success',
          });
        })
        .catch(() => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          this.closeBusDialog();
        });
    },
    downloadTemplate() {
      this.status = 'loading-download-template';
      axios
        .get('/users/download-template-for-' + this.userType, {
          responseType: 'blob',
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.userType + '_template.xlsx');
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_downloading_template'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    openUploadFile() {
      this.$refs.file.value = '';
      this.$refs.file.click();
    },
    uploadTemplateFile(event) {
      const files = event.target.files;
      let file = files[0];
      //get the selected file
      if (file) {
        this.status = 'loading-upload-file';
        let formData = new FormData();
        formData.append('file', file);
        axios
          .post('/users/upload-' + this.userType, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => {
            this.$notify({
              title: this.$t('messages.success'),
              text: this.$t('messages.file_uploaded_successfully'),
              type: 'success',
            });
            this.loadUsers();
          })
          .catch(() => {
            this.$notify({
              title: this.$t('messages.error'),
              text: this.$t('messages.error_while_uploading_file'),
              type: 'error',
            });
            // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
          })
          .then(() => {
            this.status = '';
          });
      }
    },
    exportUsers() {
      this.status = 'loading-export-users';
      const params = {
        page: this.options?.page ?? 1,
        per_page: this.options?.itemsPerPage ?? 10,
        order_by: this.options?.sortBy?.[0],
        order_direction:
          this.options?.sortDesc?.[0] === null ||
          this.options?.sortDesc?.[0] === undefined
            ? null
            : this.options?.sortDesc?.[0] === true
            ? 'DESC'
            : 'ASC',
        search: this.search,
        status: this.active_tab + 1,
      };
      axios
        .get('/users/all-' + this.userType + '-export', {
          params,
          responseType: 'blob',
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const today = new Date();
          const formattedDate = today
            .toLocaleDateString('en-GB')
            .replace(/\//g, '_');
          link.setAttribute(
            'download',
            this.userType + '_' + formattedDate + '.xlsx'
          );
          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_exporting_users'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    deleteUser(user) {
      this.$swal
        .fire({
          title: this.$t('actions.delete_user'),
          text:
            this.$t('actions.are_you_sure_to_delete_the_account_of') +
            " '" +
            user.name +
            "' ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('actions.yes_delete'),
          confirmButtonColor: '#f44336',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteUserServer(user);
          }
        });
    },
    deleteUserServer(user) {
      this.isSubmit = true;
      let userType = this.userType.slice(0, -1);
      let routeName = 'delete-' + userType;
      axios
        .delete(`/users/${routeName}`, {
          data: {
            id: user.id,
          },
        })
        .then(() => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.user_deleted'),
            type: 'success',
          });
          this.users = this.users.filter((user1) => user1.id !== user.id);
          this.activeUsers = this.users.filter(
            (user1) => user1.status_id === 1
          );
          this.suspendedUsers = this.users.filter(
            (user1) => user1.status_id === 3
          );
        })
        .catch(() => {
          this.isSubmit = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error'),
            type: 'error',
          });
        });
    },
  },
};
</script>

<style scoped>
.users-main-card { border-radius: 14px !important; border: 1px solid rgba(0,0,0,0.06) !important; overflow: hidden; }
.users-card-header { padding: 14px 20px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; }
.header-schools   { background: linear-gradient(90deg, #1565C0, #1976D2); }
.header-students  { background: linear-gradient(90deg, #E65100, #F57C00); }
.header-drivers   { background: linear-gradient(90deg, #1B5E20, #388E3C); }
.header-guardians { background: linear-gradient(90deg, #4A148C, #7B1FA2); }
.header-directors { background: linear-gradient(90deg, #BF360C, #E64A19); }
.users-card-header-left { display: flex; align-items: center; gap: 10px; }
.users-card-header-right { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.users-card-header-icon { width: 32px; height: 32px; background: rgba(255,255,255,0.2); border-radius: 8px; display: flex; align-items: center; justify-content: center; }
.users-card-header-title { color: #fff; font-size: 15px; font-weight: 700; letter-spacing: 0.3px; }
</style>
